import React, { useContext } from 'react';
import classNames from 'classnames';
import { isEmpty } from '@carecloud/cloudpak';
import styles from './group.module.scss';
import { HORIZONTAL, VERTICAL, GRID } from '../../../constants/Properties';
import { isMobileDevice } from '../../services/utilities';
import { store } from '../../../models';
import { ContextProvider } from '../../root/TopLevelContext';
import * as babyContexts from '../../../contexts';

const group = React.memo(({ children, props: { direction, theme, id, action = {} } }) => {
  // `action` can be a single action object or an array of them (e.g. open a
  // modal AND show a form on the same click, see
  // needHelpSigningInFindAccountOption) — every action in the array fires in
  // order. A single action keeps behaving exactly as before.
  const actions = Array.isArray(action) ? action : [action];
  const primaryBabyContext = actions.find(entry => entry && entry.babyContext);
  const grandpaContext = useContext(ContextProvider);
  const variableContext =
    primaryBabyContext && useContext(babyContexts[`${primaryBabyContext.babyContext}Context`]);
  const clickable = !isEmpty(action);
  const clickHandler = () => {
    actions.forEach(({ model = String(), trigger = String(), param = String(), babyContext = String() } = {}) => {
      if (model === 'localActions') grandpaContext._getAction(trigger) && grandpaContext._getAction(trigger)(param);
      else if (babyContext) variableContext[trigger](param);
      else store.dispatch[model][trigger](param);
    });
  };
  return (
    <div
      id={id}
      className={classNames(
        styles.group,
        { [styles.horizontal]: direction === HORIZONTAL },
        { [styles.vertical]: direction === VERTICAL },
        { [styles.grid]: direction === GRID },
        { [styles.isMobile]: isMobileDevice() },
        styles[theme],
      )}
      {...(clickable && { role: 'button', tabIndex: 0, onClick: clickHandler })}
    >
      {children}
    </div>
  );
});

export const Group = group;
